import { render, staticRenderFns } from "./ScriptPerPostInfoDialog.vue?vue&type=template&id=156f6f1e&"
import script from "./ScriptPerPostInfoDialog.vue?vue&type=script&lang=js&"
export * from "./ScriptPerPostInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports